import { ConstructionType } from '../../../Enum/Filters/';
import { filterFinishedLoading, filterSubmitted } from '../../../Store/Filter/action';
import { getInterestsPerProduct } from '../../../Service/Interest/InterestService';
import { InterestPerProductTableDTO } from '../../../Interface/Hook/Interest/InterestPerProductTableDTO';
import {
    INITIAL_TABLE_STATE,
    InterestPerProductTableState,
} from '../../../Interface/Hook/Interest/InterestPerProductTableState';
import { Label } from '../../../Interface/Response/Interest/Label';
import { PRODUCT_FILTERS } from '../../../Constants/Interest/Filter';
import reduceTablePerProductData from '../../../Reducer/ReduceTablePerProductData';
import { tokenExpired } from '../../../Store/Auth/action';

import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import useFilterIsActual from '../UseFilterIsActual';
import { ErrorResponse } from '../../../Interface/ErrorResponse';

const useGetInterestPerProduct = (
    constructionType: ConstructionType,
    label: Label | null,
    modificationLoanform: string,
): InterestPerProductTableDTO => {
    const dispatch = useDispatch();
    const filterIsActual = useFilterIsActual(PRODUCT_FILTERS);
    const [
        { error, data, headers, loading, extraInterest, messages },
        setState
    ] = useState<InterestPerProductTableState>(INITIAL_TABLE_STATE);

    const fetchData = useCallback(() => {
        if (label === null) return;
        if (!filterIsActual) dispatch(filterSubmitted());
        if (filterIsActual)
            getInterestsPerProduct(label, modificationLoanform, constructionType).then(
                result => {
                    setState({ error: false, ...reduceTablePerProductData(result), loading: false });
                    dispatch(filterFinishedLoading());
                },
                (errorResult: ErrorResponse) => {
                    errorResult.code === 403
                        ? dispatch(tokenExpired())
                        : setState({ error: true, data, headers, loading: false, extraInterest: {}, messages: [] });
                    dispatch(filterFinishedLoading());
                },
            );
    }, [constructionType, dispatch, filterIsActual, label, modificationLoanform, data, headers]);

    useEffect(() => fetchData(), [label, modificationLoanform, constructionType]);

    return { data, error, headers, loading, extraInterest, messages };
};

export default useGetInterestPerProduct;
